:root {
    --bg-primary-light: #D5EAED;
}

.bg-primary-light {
    background-color: var(--bg-primary-light);
}